import { useQueryWithAuth } from '@lib/Auth/clerk-utils'
import { stories } from '../model/query-keys'

export function useRecentStoriesData() {
  return useQueryWithAuth({
    ...stories.all(),
    select: (data) => data.stories.slice(0, 5),
    placeholderData: () => {
      return {
        stories: Array(5).fill({
          body: '',
          created_at: '',
          hero_image_content_type: '',
          hero_image_file_name: '',
          hero_image_file_size: '',
          hero_image_path: '',
          hero_image_updated_at: '',
          id: 0,
          published_date: '',
          title: '',
          updated_at: '',
        }),
      }
    },
  })
}
